import { render, staticRenderFns } from "./videoSettingsCard.vue?vue&type=template&id=4e0a2292&scoped=true&"
import script from "./videoSettingsCard.vue?vue&type=script&lang=js&"
export * from "./videoSettingsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0a2292",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VCard,VCardSubtitle,VCardText,VCheckbox,VDivider,VSlider})
